module.exports = __webpack_public_path__ + "img/2021_ISO9001-ISO14001-ISO45001_White_UKAS_SystemCert_COLOUR.2b146c5a.jpg";